import { motion } from "framer-motion";
import { Download, Eye, Plus, Save, Send } from "lucide-react";
import { useState } from "react";
import moment from "moment";
import { toast } from "wc-toast";

export default function AIImageHistory({
  navigate,
  send_for_calendar,
  setShowSaveModal,
  myimages,
  previewOpen,
  setPreviewOpen,
  selectedRow,
  setSelectedRow,
}) {
  const isMobile = window.innerWidth < 768;

  const styles = {
    page: {
      background: "#0b0e11",
      height: "100vh",
      padding: isMobile ? 16 : 32,
      color: "#fff",
      fontFamily: "Inter, sans-serif",
      display: "flex",
      flexDirection: "column",
      boxSizing: "border-box",
    }
    ,

    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: isMobile ? "flex-start" : "center",
      flexDirection: isMobile ? "column" : "row",
      gap: 12,
      marginBottom: 24,
    },

    title: {
      fontSize: 18,
      fontWeight: 600,
    },

    button: {
      display: "flex",
      alignItems: "center",
      gap: 8,
      background: "#fff",
      color: "#000",
      padding: "10px 16px",
      borderRadius: 10,
      fontWeight: 600,
      cursor: "pointer",
      border: "none",
      width: isMobile ? "100%" : "auto",
      justifyContent: "center",
    },

    tableWrapper: {
      overflowY: "auto",
      //  maxHeight: "calc(100vh - 180px)",
    },

    table: {
      border: "1px solid #1f2937",
      borderRadius: 14,
      overflow: "hidden",
    },

    headerRow: {
      display: isMobile ? "none" : "grid",
      gridTemplateColumns: "100px 1fr 160px 120px 140px",
      padding: "14px 18px",
      background: "#0f141a",
      fontWeight: 600,
      color: "#cbd5e1",
    },

    row: {
      display: isMobile ? "flex" : "grid",
      gridTemplateColumns: isMobile
        ? "none"
        : "100px 1fr 160px 120px 140px",
      flexDirection: isMobile ? "column" : "unset",
      gap: isMobile ? 12 : 0,
      padding: 16,
      alignItems: isMobile ? "flex-start" : "center",
      borderTop: "1px solid #1f2937",
      background: "#0b0e11",
    },

    image: {
      width: 64,
      height: 64,
      borderRadius: 8,
      objectFit: "cover",
      flexShrink: 0,
    },

    description: {
      fontSize: 14,
      lineHeight: "18px",
      textAlign: "left",
    },

    meta: {
      fontSize: 12,
      color: "#9ca3af",
    },

    actions: {
      display: "flex",
      alignItems: "center",
      gap: 14,
      flexWrap: "wrap",
    },

    iconBtn: {
      cursor: "pointer",
      color: "#F7941D",
    },
  };

  function truncateText(text = "", max = 100) {
    if (text.length <= max) return text;
    return text.slice(0, max) + "...";
  }

  function downloadImage(url, fileName = "AI-image.png") {
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    toast.success("Image downloaded successfully");
  }

  return (
    <div style={styles.page}>
      <wc-toast></wc-toast>

      {/* Header */}


      {/* Table */}
      <div style={styles.tableWrapper}>
        <div style={styles.table}>

          <div style={styles.headerRow}>
            <div>Image</div>
            <div>Description</div>
            <div>Date</div>
            <div>Time</div>
            <div>Actions</div>
          </div>

          {myimages.map((row, index) => (
            <motion.div
              key={row.image_id}
              style={styles.row}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.05 }}
              whileHover={!isMobile ? { backgroundColor: "#111827" } : {}}
            >
              <img src={row.generated_url} style={styles.image} />

              <div style={{ width: "100%" }}>
                <div style={styles.description}>
                  {truncateText(
                    row.description,
                    isMobile ? 70 : 140
                  )}
                </div>

                {isMobile && (
                  <div style={styles.meta}>
                    {moment(new Date(row.image_id)).format(
                      "DD MMM YYYY • hh:mm A"
                    )}
                  </div>
                )}
              </div>

              {!isMobile && (
                <>
                  <div>
                    {moment(new Date(row.image_id)).format("DD MMM YYYY")}
                  </div>
                  <div>
                    {moment(new Date(row.image_id)).format("hh:mm A")}
                  </div>
                </>
              )}

              <div style={styles.actions}>
                <Eye
                  onClick={() => {
                    setSelectedRow({ ...row });
                    setPreviewOpen(true);
                  }}
                  style={styles.iconBtn}
                  title="Preview"
                />

                <Save
                  onClick={() => setShowSaveModal(row)}
                  style={styles.iconBtn}
                  title="Save to Content"
                />

                <Send
                  onClick={() =>
                    send_for_calendar(row.generated_url)
                  }
                  style={styles.iconBtn}
                  title="Send to Devices"
                />

                <Download
                  onClick={() => downloadImage(row.generated_url)}
                  style={styles.iconBtn}
                  title="Download"
                />
              </div>
            </motion.div>
          ))}

        </div>
      </div>
    </div>
  );
}
